/* AZBEAUTYK — détecte les déclencheurs de fidélité chargés après le thème,
   y compris dans les shadow DOM ouverts. Ne modifie pas le fonctionnement des clics. */
(function(){'use strict';
var seen=new WeakSet(),pending=false;
function isReward(el){
 if(!el || !el.matches || !el.matches('button,a,[role="button"],input[type="button"]'))return false;
 var label=[el.getAttribute('aria-label'),el.getAttribute('title'),el.getAttribute('data-testid'),el.getAttribute('data-name'),el.innerText,el.textContent,el.value].filter(Boolean).join(' ').replace(/\s+/g,' ').trim();
 return /(?:récompens|recompens|rewards?|loyalty)/i.test(label) && label.length<160;
}
function scan(root){
 if(!root || !root.querySelectorAll)return;
 var nodes=root.querySelectorAll('button,a,[role="button"],input[type="button"]');
 for(var i=0;i<nodes.length;i++){
  var el=nodes[i];
  if(isReward(el) && !el.closest('nav,header,footer,[role="dialog"],dialog'))el.classList.add('azb-rewards-magic');
 }
 var all=root.querySelectorAll('*');
 for(var j=0;j<all.length;j++){
  if(all[j].shadowRoot){watch(all[j].shadowRoot);scan(all[j].shadowRoot)}
 }
}
function watch(root){if(seen.has(root))return;seen.add(root);new MutationObserver(queue).observe(root,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','title','class']});}
function queue(){if(pending)return;pending=true;requestAnimationFrame(function(){pending=false;scan(document);});}
function start(){watch(document.documentElement);scan(document);setTimeout(queue,1000);setTimeout(queue,3500);setTimeout(queue,8000);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
